// extracted by mini-css-extract-plugin
export default {"fixed":"ScrollToTop_fixed__oK9tL","button":"ScrollToTop_button__2ejzo","icon":"ScrollToTop_icon__-N7rG"};